import indexedDBUtils from "@/utils/indexedDBUtils";
import configUtils from "@/utils/configUtils";
import VueAxios from 'vue-axios';

const funcs = {
    userAndTokenReceived: function (data, handle, cb) {
        data.user.tempPassword = data.tempPassword;
        funcs.setCookie('user', JSON.stringify(data.user));
        handle.$store.commit('updateUser', data.user);
        cb();
    },
    checkAuth: function (handle, callback) {
        if (handle.$store.state.user.cookieToken && handle.$store.state.user.username) {
            if (callback) {
                callback(handle.$store.state.user.username);
            }
        } else {
            handle.$router.replace(handle.$config.get('basePathFiles') + "logout?redirect=" + handle.$router.currentRoute.path);
        }
    },
    logout: function (handle, callback) {
        funcs.deleteCookies();
        handle.$store.commit('updateUser', {});
        indexedDBUtils.clearDB(function() {
            var logoutUrl = handle.$config.get('ecApi') + "login/logout";
            axios.get(logoutUrl).then(_ => {
                callback();
            }).catch(_ => {
                callback();
            });
        });
    },
    isLoggedIn: function (store) {
        return store.state.user && store.state.user.cookieToken && store.state.user.username;
    },
    getCookie: function(name) {
        return $cookies.get(name);
    },
    setCookie: function(name, value) {
        return $cookies.set(name, value);
    },
    deleteCookies: function() {
        $cookies.remove("aid");
        $cookies.remove("user");
    },
    isStudent: function(user) {
        return user.roles.indexOf('student') >= 0;
    },
    isITSIAnywhere: function(user) {
        return user.roles.indexOf('anywhere') >= 0;
    },
    isAllowedRole: function(handle, user) {        
        return configUtils.getSettingsProperty(handle, "access").then(access => {
            if (access) {
                return user.roles.some(r => access.indexOf(r) >= 0);
            } else return false
        });
    }
}

export default funcs;
